import { useNavigate, useSearchParams } from 'react-router-dom';
import { ClipboardList, MapPin, MessageSquareText, Phone } from 'lucide-react';
import { InquiryForm } from '../components/InquiryForm';
import { PageHero, Checklist, InlineLink } from '../components/interior/PageElements';
import { services } from '../data/services';
import { cities } from '../data/cities';
import { business, phoneHref } from '../data/business';

export default function InquiryPage({ quote = false }) {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const service = services.find(item => item.slug === params.get('service'));
  const city = cities.find(item => item.slug === params.get('city'));
  const context = [service ? `Service: ${service.title}` : '', city ? `Location: ${city.name}, TX` : ''].filter(Boolean).join('\n');
  const title = quote ? 'Let’s talk about your project.' : 'Start the conversation.';
  return <>
    <PageHero
      eyebrow={`LONGHORN MILLING / ${quote ? 'REQUEST A QUOTE' : 'CONTACT'}`}
      title={title}
      description={quote
        ? 'Tell us about the site, the scope, and what you have planned. Start with what you know.'
        : 'Have a question about a site, service, or project requirement? Send a message to Longhorn Milling.'}
      breadcrumbs={[{ label: quote ? 'Request a Quote' : 'Contact' }]}
    />
    <section className="site-section">
      <div className="site-container inquiry-page-grid">
        <div className="inquiry-page-intro">
          <p className="eyebrow dark" data-testid="inquiry-intro-label">{quote ? 'YOUR PROJECT DETAILS' : 'GET IN TOUCH'}</p>
          <h2 data-testid="inquiry-intro-heading">A few details.<br />A useful starting point.</h2>
          <p data-testid="inquiry-intro-copy">Include an email address or phone number with your message. Project scope, equipment, and scheduling are subject to confirmation.</p>
          <div className="contact-detail"><Phone size={22} aria-hidden="true" /><div><strong data-testid="inquiry-business-phone-label">Let’s talk about your project</strong><a href={phoneHref} className="text-link" data-testid="inquiry-business-phone">{business.phoneDisplay}</a></div></div>
          <div className="contact-detail">
            <MapPin size={22} aria-hidden="true" />
            <div>
              <strong data-testid="contact-region">Dallas–Fort Worth / North Texas</strong>
              <InlineLink to="/service-areas/" id="inquiry-areas-link">Explore project locations</InlineLink>
            </div>
          </div>
          <div className="contact-detail">
            <ClipboardList size={22} aria-hidden="true" />
            <div>
              <strong data-testid="quote-guidance-heading">Helpful to include</strong>
              <Checklist id="inquiry-guidance" items={['Site location and approximate work area', 'Pavement needs and planned next steps', 'Timing, access, and project restrictions']} />
            </div>
          </div>
          <InlineLink to="/resources/" id="inquiry-resources-link">View the project checklist</InlineLink>
        </div>
        <div className="inquiry-form-surface" data-testid="inquiry-form-surface">
          <div className="form-heading">
            <MessageSquareText size={24} aria-hidden="true" />
            <h2 data-testid="inquiry-form-heading">{quote ? 'Request a Quote' : 'Send an inquiry'}</h2>
          </div>
          <InquiryForm key={`${quote}-${context}`} projectContext={context} onDone={() => navigate('/')} />
          <p className="form-privacy-note" data-testid="inquiry-privacy-note">Your inquiry and contact details are saved with your request. Submitting does not reserve a work date.</p>
        </div>
      </div>
    </section>
  </>;
}